import "../../../foundation/forms";
import { sendGAPageView } from "../../../foundation/utils/tracking";
import { toCamelCase } from "../../../foundation/utils/string";
import PreactDOMComponent from "../../../foundation/utils/preact-dom-component";
import ForgotPasswordPage from "../../containers/LoginSignup/pages/ForgotPasswordPage";

sendGAPageView();

const ForgotPasswordDOMComponent = new PreactDOMComponent(ForgotPasswordPage, document.body);
const forgotPasswordParams = {};

if (location.search) {
    location.search.substr(1).split("&").forEach(param => {
        const kv = param.split("=");

        forgotPasswordParams[toCamelCase(decodeURIComponent(kv[0]))] = decodeURIComponent(kv[1]);
    });

    history.replaceState({}, "Zeplin - Reset Password", location.pathname);
}

ForgotPasswordDOMComponent.render({ forgotPasswordParams });
